if (!customElements.get('image-text-swiper-full-width')) {
    class ImageTextSwiperFullWidth extends HTMLElement {
        constructor() {
            super();
            this.swiper = null;
            this.swiperContainer = this.querySelector('.swiper');
        }

        connectedCallback() {
            this.initSwiper();
        }

        initSwiper() {
            if (this.swiperContainer) {
                const nextButton = this.querySelector('.swiper-button-next');
                const prevButton = this.querySelector('.swiper-button-prev');
                const pagination = this.querySelector('.swiper-pagination');
                this.swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: nextButton,
                        prevEl: prevButton,
                    },
                    pagination: {
                        el: pagination,
                    },
                    autoHeight: true,
                });
            }
        }
    }

    customElements.define('image-text-swiper-full-width', ImageTextSwiperFullWidth);
}
